<div class="switch-theme">
  @for (theme of themes; track theme) {
    <span (click)="onSwitchTheme(theme)">{{ theme.label }}</span>
  }
</div>
